import { Component, OnInit, OnDestroy,SecurityContext,ViewChild,ElementRef } from '@angular/core';
import {SafeUrl} from '@angular/platform-browser';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { ExamsService} from '../exams.service';
import {PregnancyService} from '../pregnancy.service';
import {AutotextService} from '../autotext.service';
import { DomSanitizer,SafeHtml} from '@angular/platform-browser';
import { LoginService } from '../login.service';
import {VideoCaptureService} from '../video-capture.service';
import {VideoClientService} from '../video-client.service';
import { Router } from '@angular/router';
import {TimerService} from '../timer.service';
import { Subscription } from 'rxjs';
import {GalleryService} from '../gallery.service';
import { Location } from '@angular/common';
import { UsgService } from '../usg.service';
import { SignatureService } from '../signature.service';
import { MedicationService } from '../medication.service';
import { PathologyService } from '../pathology.service';
import { MatDialog } from '@angular/material/dialog';
import { PrescriptionDialogComponent } from '../prescription/prescription-dialog.component';
import { BloodTestReferralDialogComponent } from '../blood-test-referral/blood-test-referral-dialog.component';
import { ConsentFormsComponent } from '../consent-forms/consent-forms.component';
import { resolveConsentTypeKey } from '../consent-types';


@Component({
    selector: 'app-exam',
    templateUrl: './exam.component.html',
    styleUrls: ['./exam.component.scss'],
    standalone: false
})
export class ExamComponent implements OnInit, OnDestroy {
  @ViewChild('videobox') videoElement: ElementRef;
  @ViewChild('imgcanvas') imageCanvas: ElementRef;
  fetuses:number = 1;
  showSide: boolean= false;
  page:string = "Pregnancy";
  pat:Patient;
  showPat = false;
  showgallery=false;
  showcharts=false;
  showprint=false;
  showprintopts=true;
  showInbox = false;
  openDocumentsAdd = false;
  recording = false;
  recordLink: SafeUrl;
  CurrentSR: number;
  CurrentInbox: number;
  vidMinified: boolean;
  videoSource: string;
  audioSource: string;
  Stream: MediaStream;
  soundtest: boolean;
  audioInputs:{ value: any, text: any }[];
  videoInputs:{ value: any, text: any }[];
  videowarn = false;
  SR: SafeHtml;
  noStop = false;
  showdeleteimg = false;
  exitTimeout;
  fullscreen=false;
  ExamSubscription:Subscription;
  showlink=false;
  sub : Subscription;
  private examSignedSub: Subscription;
  private alertToSignSub: Subscription;
  takePicSubsctiption: Subscription;
  phototaken: SafeUrl;
  showTimmer;
  messages: string;
  sendonce =false;
  showSelect = false;
  concentForm;
  inform = false;
  linkedUsgConsent: any = null;
  showUsgConsentForm = false;
  consentFormToEdit: any = null;
  // linksent = 0;
  audioLevel: number = 0;

  // Exam Signature:
  showAlertToSign: boolean = false;
  exitToPatSearch: boolean = false;


  constructor(
    private location: Location,
    private patservice: PatientsService,
    public vs: VideoCaptureService,
    private vidClient: VideoClientService,
    public ps: PregnancyService,
    public atS: AutotextService,
    private sanitizer: DomSanitizer,
    public ls: LoginService,
    private router: Router,
    public ts: TimerService,
    public gs: GalleryService,
    public es: ExamsService,
    public gastroService: UsgService,
    public medicationService: MedicationService,
    public signatureService: SignatureService,
    public pathologyService: PathologyService,
    private dialog: MatDialog,
  ) {
    this.vidMinified=false;
    this.audioInputs = [];
    this.videoInputs = [];
    this.gs.isOpen=false;
    this.ExamSubscription = this.es.examLoaded$.subscribe(async ()=>{
      if(this.es.isClinicsBuilderExam && this.page !== 'ClinicsExam')
        this.page = 'ClinicsExam';
      if(! this.es.isClosed){
        this.exitTimeout = setTimeout(()=>{this.exit()}, 120 * 60 * 1000);
      } else{ 
        if(this.es.ExamType != "Emergency Room"){
          this.showprintopts = false;
          this.showprint = true;
        }
      }
      
      if(this.es.ExamType != 'Follicles' && this.es.ExamType != 'Gynecology' && this.patservice.getPat().ID != 'default' && ! this.es.isForm)
        this.ps.setExamID(this.es.examID,this.es.CreationTime);
      this.sendonce = this.es.LinkSent;
    });
   }

  async ngOnInit() {
    const isExamSigned = this.signatureService.isExamSigned(this.es.examObject);
  
    this.es.loginMissing();
    this.getCountLinks()
    this.pat=this.patservice.getPat();
    if (this.es.ExamType === 'Endoscopy' && this.ls.premissions?.Consent && this.pat.ID !== 'default') {
      this.loadLinkedUsgConsent();
    }
    //this.recordLink = this.sanitizer.bypassSecurityTrustUrl('ArtisanImage:Start' + this.es.examID);
    this.es.ShowSRs=false;
    
    // this.cookie=this.cookieServ.get('connect.sid');
    if(this.pat?.ID == 'default')
      this.page = 'Placenta';

    if (this.ls.isUSG && this.es.ExamType !== "Abdomen US" && this.es.ExamType !== 'MSK Musculoskeletal' && this.es.ExamType !== 'MSK & Soft Tissues' && this.es.ExamType !== 'Neck scan' && this.es.ExamType !== 'Ultrasound Scan Summary' && this.es.ExamType !== 'Hemorrhoids Treatment') {
      this.page = "Preparation";
    } else if (this.es.ExamType === 'Hemorrhoids Treatment') {
      this.page = "Procedure Summary";
    } else if (this.es.ExamType === 'MSK Musculoskeletal') {
      this.page = "MSK Musculoskeletal";
    } else if (this.es.ExamType === 'MSK & Soft Tissues') {
      this.page = "MSK & Soft Tissues";
    } else if (this.es.ExamType === 'Neck scan') {
      this.page = "Neck scan";
    } else if (this.es.ExamType === 'Ultrasound Scan Summary') {
      this.page = "Ultrasound Scan Summary";
    } else if (this.es.ExamType === 'Endoscopy') {
      this.page = "Preparation";
    } else {
      this.page = "Abdomen US";
    }
    if(this.es.loadedFromLabResults){
      if(this.es.loadedFromLabResults == 'needsPayer'){
        this.page = 'SummaryGastro';
      }
      else {
        this.page = 'Pathologies';
      }
    }

    if(this.es.isForm)
      this.page = 'forms';
    if(this.es.isClinicsBuilderExam)
      this.page = 'ClinicsExam';
    if(this.ls.Recording == 'webrtc'  && ! this.ls.RemoteRTC && this.pat.ID != "default" && ! this.es.isForm && this.es.ExamType != 'Emergency Room' && ! this.es.isClosed){
      let inputs = await this.vs.getDevices();
      this.videoInputs = inputs.video;
      this.audioInputs = inputs.audio;
      try{
        let oldv = window.localStorage.getItem("video");
        if(oldv && this.videoInputs.find((item)=> {return item.value == oldv})){
          this.videoSource = oldv;
        }
        var olda = window.localStorage.getItem("audio");
        if(olda&& this.audioInputs.find((item)=> {return item.value == olda})){
          this.audioSource = olda;
        }
        await this.startVideo();
        if(this.ls.isUSG){
          this.vs.ExamID =  this.es.examID;
          this.vs.openWebSocket();//for image capture messages
        }       
          this.vs._photoS.subscribe((photo)=>{
            this.imageCanvas.nativeElement.width = photo.width;
            this.imageCanvas.nativeElement.height = photo.height;
            this.imageCanvas.nativeElement.getContext('2d').drawImage(photo, 0, 0);
            this.imageCanvas.nativeElement.style.display = 'block';
            try{
              if(this.showTimmer)
                clearTimeout(this.showTimmer);
            }
            catch(e){
              console.log(e);
            }
            this.showTimmer  = setTimeout(()=>{
              this.imageCanvas.nativeElement.style.display = 'none';
            },3000);
          });
        }
        catch(e){
        console.log(e);
      }
    }
    if(this.ls.RemoteRTC && ! this.es.isClosed){
      this.vidClient.GotStream.subscribe(()=>{
        this.Stream = this.vidClient.Stream;
      });
      this.vidClient.ConnectServer();
    }
   
    if(! this.ls.isCardio)
      this.sub = this.es.titleChange.subscribe(
        (res) => {
          this.es.changedTitle = res
          if(res){
          }
        }
      );
  
    // Enable all fields if exam is not signed:
    if (!isExamSigned) {
      this.medicationService.Medication.enable({ emitEvent: false });
      this.pathologyService.pathologyForm.enable({ emitEvent: false });
      this.gastroService.gastroForm.enable({ emitEvent: false });
    }

    // Login for edit:
    if (this.es.isLoginForEdit) {
      this.es.isClosed = false;
      this.showprint = false;
      this.gastroService.gastroForm.enable({ emitEvent: false });
      this.medicationService.Medication.enable({ emitEvent: false });
      this.pathologyService.pathologyForm.enable({ emitEvent: false });
      this.es.signed = false;
    }

    this.examSignedSub = this.es.examSigned$.subscribe((data) => {
      this.es.examObject = data;
      this.signatureService.isExamSigned(this.es.examObject);
    });

    this.alertToSignSub = this.signatureService.alertToSign$.subscribe((shouldAlert) => {
      if (shouldAlert && !this.es.isClosed) {
        this.showAlertToSign = true;
      }
    });

  }

  ngAfterViewInit() {
    // Get access to the microphone audio stream
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        this.videoElement.nativeElement.srcObject = stream;

        // Create an audio context and analyzer
        const audioContext = new AudioContext();
        const analyzer = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);

        microphone.connect(analyzer);

        // Continuously update audio level
        const updateAudioLevel = () => {
          const dataArray = new Uint8Array(analyzer.frequencyBinCount);
          analyzer.getByteFrequencyData(dataArray);
          const average =
            dataArray.reduce((acc, val) => acc + val, 0) / dataArray.length;
          this.audioLevel = Math.floor((average / 255) * 100); // Convert to 0-100 scale
          requestAnimationFrame(updateAudioLevel);
        };

        audioContext.resume().then(() => {
          updateAudioLevel(); // Start updating audio level
        });
      })
      .catch((error) => {
        console.error("Error accessing microphone:", error);
      });
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.es.isLoginForEdit=false
    if(this.exitTimeout)
      clearTimeout(this.exitTimeout);
    if(this.ls.RemoteRTC)
      this.vidClient.StopRecording();
    else{
      this.vs.Clean();
      this.vs.closeWebSocket();
    }
    // this.es.exitExam();
    if (this.ExamSubscription) {
      this.ExamSubscription.unsubscribe();
    }

    if (this.sub) {
      this.sub.unsubscribe();
    }

    if (this.takePicSubsctiption) {
      this.takePicSubsctiption.unsubscribe();
    }

    if (this.examSignedSub) {
      this.examSignedSub.unsubscribe();
    }

    if (this.alertToSignSub) {
      this.alertToSignSub.unsubscribe();
    }
  }

  setPage(pg: string){
    this.page = pg;
    this.ls.tabChanged$.next(pg);
  }

  startForm(){
    this.es.ps.resetPreg()
    var temp = this.es.pregnancies.filter((i) => i.AutoIndex == this.es.ps.pregID)
    if(temp.length > 0){
      // var res = this.es.getConcentForms();
      // res.subscribe((data) =>{
      //   temp = data
      // })
      temp = temp[0].forms.filter((i) => (i.ExamID == this.es.examID) || (!i.ExamID && i.ExamType == this.es.ExamType))
    } 
    if(temp.length>0)
      this.concentForm = temp[0]
    else
      this.concentForm = null;

      this.inform =true;
  }

  changeFetuses(n: number){
    this.fetuses = n;
  }

  record(){
    if(this.ls.RemoteRTC  && ! this.noStop){
      this.noStop = true;//don't allow to stop recording in less than 5 secons
      if(this.vidClient.Recording ){
        this.vidClient.StopRecording();
      }
      else if(! this.vidClient.Recording ){
        this.vidClient.StartRecording();
      }
      setTimeout(()=>{
        this.noStop = false;
      }, 5000);
    }
    else{
      if(! this.noStop){
        this.noStop = true;
        this.vs.Record(this.es.examID);
        setTimeout(()=>{
          this.noStop = false;
        }, 2000);
      }
    }
  }

  isRecording():boolean{
    if(this.ls.RemoteRTC)
      return this.vidClient.Recording;
    else
      return this.vs.recording;
  }

  openGallery(inbox:number){
    this.CurrentInbox= inbox;
    this.showgallery=true;
  }

  async startVideo(){
    this.Stream = await this.vs.startVideo(this.videoSource,this.audioSource,this.soundtest);
  } 

  loadSR(sr:number){
    this.CurrentSR = sr;
    this.es.getSR(sr).subscribe((data)=>{
      this.SR = this.sanitizer.sanitize(SecurityContext.HTML, data);
    }, (err) =>{
      console.log(err);
    })
  }

  exit(patlist = false){
    this.es.exitExam();
    if(this.ls.isCardio && this.ls.userType == 'secretary'){
      this.location.back()
    }else{
      this.router.navigateByUrl(patlist ? '/patsearch':'/exams');
    }
  }

  openPrescription() {
    const pat = this.patservice.getPat();
    this.dialog.open(PrescriptionDialogComponent, {
      data: {
        PID: pat.PID ? pat.PID.toString() : pat.ID,
        GID: this.ls.GID,
        patientName: (pat.First || '') + ' ' + (pat.Last || ''),
        patientID: pat.ID,
        patientDOB: pat.Birth,
        HMO: pat.HMO || '',
        examID: this.es.examID
      },
      width: '980px',
      height: '700px'
    });
  }

  openReferral() {
    const pat = this.patservice.getPat();
    this.dialog.open(BloodTestReferralDialogComponent, {
      data: {
        PID: pat.PID ? pat.PID.toString() : pat.ID,
        GID: this.ls.GID,
        patientName: (pat.First || '') + ' ' + (pat.Last || ''),
        patientID: pat.ID,
        patientDOB: pat.Birth,
        HMO: pat.HMO || '',
        examID: this.es.examID
      },
      width: '1150px',
      height: '820px'
    });
  }

  handleClose(place: string) {
    const examObject = this.es.examObject;
    const isDoctor = this.es.isDoctor();
    const isExamSigned = this.signatureService.isExamSigned(examObject);
    const isClosed = this.es.isClosed;

  

    if (isDoctor && !isExamSigned && !isClosed ) {
      this.showAlertToSign = true;
      this.exitToPatSearch = true;
    } else {
      this.es.exitExam();
      if (this.ls.userType == "secretary") {
        this.location.back();
        return;
      }
      this.router.navigateByUrl(place);
    }
  }

  leaveSignAlert() {
    this.showAlertToSign = false;
    this.exit(this.exitToPatSearch ? true : false);
  }

  maximizeVid(){
    this.videoElement.nativeElement.requestFullscreen();
  }

  handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
  }

  togglefullscreen(){
    this.fullscreen = ! this.fullscreen;
  }

  deleteMedia(){
    this.gs.delete();
    this.showgallery = false;
    this.showdeleteimg = false;
    setTimeout(()=> {this.showgallery = true}, 100);
  }

  getDisk(){
    if(this.messages == 'Creating Disk ...')
      return;
    this.messages = "Creating Disk ...";
    this.es.getDisk().subscribe((data)=>{
      this.messages = "Downloading disk";
      setTimeout(()=>{
        this.messages = 'When buring disk or onkey ignore the "Not Responding" message';
        setTimeout(()=>{
          this.messages = null; 
        },10000);
      },2000);
      var element = document.createElement('a');
      element.setAttribute('href','/api/readydisk/' + data['disknum'] + '/' + data['disk']);
      element.setAttribute('download', data['disk']);
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      //window.location.href = '/api/readydisk/' + data['disknum'] + '/' + data['disk'];
    },(err)=>{
      this.messages = 'Disk Creation failed';
      setTimeout(()=>{
        this.messages = null;
      },3000);
    });
  }

  closeConcent(event){
    console.log(event);
    this.inform=false;
  }

  getCountLinks(){
   this.ls.countLinks();
  }

  loadLinkedUsgConsent() {
    const examDate = new Date(this.es.CreationTime).toDateString();
    this.es.getUsgConsents(this.pat.PID.toString()).subscribe((data: any[]) => {
      const sameDay = (data || []).filter(c => new Date(c.CreationTime).toDateString() === examDate);
      const consentKey = this.es.subExamType === 'HRA' ? 'HRA' : 'Endoscopy';
      this.linkedUsgConsent = sameDay.find(c => resolveConsentTypeKey(c.ConsentType) === consentKey) || null;
    });
  }

  checkApprovedUsgConsent(consent: any): boolean {
    return !!(consent?.docSign && consent?.patSign);
  }

  openConsentForms() {
    const ref = this.dialog.open(ConsentFormsComponent, {
      data: { pat: this.pat },
      width: '900px',
      height: '650px'
    });
    ref.afterClosed().subscribe((result: any) => {
      if (result?.openForm) {
        this.consentFormToEdit = result.form || null;
        this.showUsgConsentForm = true;
      } else {
        this.refreshLinkedUsgConsent();
      }
    });
  }

  closeUsgConsentForm() {
    this.showUsgConsentForm = false;
    this.refreshLinkedUsgConsent();
  }

  private refreshLinkedUsgConsent() {
    if (this.es.ExamType === 'Endoscopy' && this.ls.premissions?.Consent && this.pat.ID !== 'default') {
      this.loadLinkedUsgConsent();
    }
  }

}
